<bb-page-header 
	[icon]="'share-alt'" 
	[title]="'SOCIAL' | translate" 
	[filterConfig]="filterConfig"
	[currentPath]="listConfiguration.basePath">
</bb-page-header>

<div class="body-column">
	<a class="button create-channel" (click)="createChannel = !createChannel"><i class="fa-solid fa-plus"></i>
		<span>{{ 'CONNECT_SOCIAL' | translate | lowercase}}</span>
	</a>
	<div class="channel-buttons" *ngIf="createChannel">
		<a class="button channel-button" [routerLink]="['/library/social/new/general']"><i class="fa-brands fa-youtube"></i>
			<span class="channel-type">{{ 'YOUTUBE' | translate }}</span>
		</a>
		<a class="button channel-button" [hasPublicationField]="'enableFacebook'" [routerLink]="['/library/social/facebook/new/general']">
			<i class="fa-brands fa-facebook"></i>
			<span class="channel-type">{{ 'FACEBOOK' | translate }}</span>
		</a>
		<a class="button channel-button" [hasPublicationField]="'enableInstagram'" [routerLink]="['/library/social/instagram/new/general']"><i class="fa-brands fa-instagram"></i>
			<span class="channel-type">{{ 'INSTAGRAM' | translate }}</span>
		</a>
	</div>

	<bb-table-container class="socials-theme">
		<caption>
			{{ 'SOCIAL_ACCOUNTS' | translate }}
		</caption>
		<bb-table-header theme="socials-theme">
			<!-- for correct rendering (and correct order), 'buttons' also needs to be in the switchCase -->
			<ng-container *ngFor="let field of sortedOrder">
				<ng-container [ngSwitch]="field">
					<bb-table-header-cell *ngSwitchCase="'id'" theme="socials-theme" property="id">{{ 'ID' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'profilePicture'" theme="socials-theme" property="profilePicture" class="icon">{{ 'ACCOUNT' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'remotePageTitle'" theme="socials-theme" property="remotePageTitle" [hideSorting]="true">{{ 'TITLE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'remoteUrl'" theme="socials-theme" property="remoteUrl">{{ 'URL' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'synced'" theme="socials-theme" property="synced">
						<span *ngIf="bigScreen" class="long-label">{{ 'SYNCED_MEDIA' | translate }}</span>
						<span *ngIf="!bigScreen" class="short-label">{{ 'SYNCED' | translate }}</span>
					</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'automatedSync'" theme="socials-theme" property="automatedSync">{{ 'AUTOMATED_SYNC' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'createddate'" theme="socials-theme" property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'createdBy'" theme="socials-theme" optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'updateddate'" theme="socials-theme" property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'updatedBy'" theme="socials-theme" optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'status'" theme="socials-theme" property="status" class="icon">{{ 'STATE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell *ngSwitchCase="'buttons'" theme="socials-theme" property="buttons" class="buttons" [hideSorting]="true"></bb-table-header-cell>
				</ng-container>
			</ng-container>
		</bb-table-header>

		<bb-table-row theme="socials-theme" *ngFor="let row of rows" [row]="row">
			<ng-container *ngFor="let rowField of sortedOrder">
				<ng-container [ngSwitch]="rowField">
					<bb-table-cell *ngSwitchCase="'id'" theme="socials-theme" optional property="id">{{ row.data.id }}</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'profilePicture'" theme="socials-theme" property="profilePicture">
						<div class="profile-container">
							<img *ngIf="row.profilePicture" (error)="row.profilePicture = false" class="profile-picture" [src]="row.profilePicture">
							<img *ngIf="!row.profilePicture" class="profile-picture" src="/resources/img/default-avatar.svg">
							<i class="fa-2x fa-brands fa-{{ row.data.subtype | lowercase }} icon"></i>
						</div>
					</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'remotePageTitle'" theme="socials-theme" property="remotePageTitle" class="overflow"> 
						<div class="page-name" [ngClass]="{'no-page-name': !row.data.remotePageTitle}">{{ row.data.remotePageTitle }}</div>
						<div *ngIf="row.data.name" class="name-tag">@{{ row.data.name }}</div>
					</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'remoteUrl'" theme="socials-theme" property="remoteUrl" class="overflow"><a target="_blank" href="{{ row.data.remoteUrl }}">{{ row.data.remoteUrl }}</a></bb-table-cell>
					<bb-table-cell *ngSwitchCase="'synced'" theme="socials-theme" property="synced">{{ syncedCounts[row.data.id] }}</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'automatedSync'" theme="socials-theme" property="automatedSync"><i class="fa fa-check" *ngIf="row.data.automatedSync"></i></bb-table-cell>
					<bb-table-cell *ngSwitchCase="'createddate'" theme="socials-theme" property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'createdBy'" theme="socials-theme" optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'updateddate'" theme="socials-theme" property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'updatedBy'" theme="socials-theme" optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
					<bb-table-cell *ngSwitchCase="'status'" theme="socials-theme" property="status"><span [ngClass]="row.data.status === 'active' ? 'status-active' : 'status-inactive'" [innerHTML]="row.data | statusIcon:'socials-theme'"></span></bb-table-cell>
					<bb-table-cell *ngSwitchCase="'buttons'" theme="socials-theme" property="buttons" class="buttons">
						<a [routerLink]="[(
							row.data.subtype === 'YouTube' && '/library/social' ||
							row.data.subtype === 'Facebook' && '/library/social/facebook' ||
							row.data.subtype === 'Instagram' && '/library/social/instagram'
						), row.data.id, 'general']">
							<bb-button [naked]="true">
								<i class="far fa-pen"></i>
							</bb-button>
						</a>
		
						<a [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)">
							<bb-button [naked]="true">
								<i class="far fa-trash-can"></i>
							</bb-button>
						</a>
					</bb-table-cell>
				</ng-container>
			</ng-container>

		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_RESULTS_FOUND' | translate }}</div>

	<bb-table-pager theme="socials-theme"></bb-table-pager>
</div>
